//@flow

import {useState, useEffect} from 'react';
import {useIsFeatureInTier} from '../../../../utils/component';
import {
  getStorePoliciesAndPrivacyConfigApi,
  saveStorePoliciesAndPrivacyConfigApi,
} from '../api';

import {actions} from '../duck';
import {useToastActions} from '../../../toast-alert/utils';
import {useActions} from '../../../../utils/globalStore';

import type {PoliciesAndPrivacy} from '../duck';
import type {RootState} from '../../..';
import {useSelector} from 'react-redux';

export default function useStorePoliciesAndPrivacy() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const [
    policiesAndPrivacy,
    setPoliciesAndPrivacy,
  ] = useState<PoliciesAndPrivacy | null>(null);

  const {showToast} = useToastActions();

  const hasTermsNConditionsInformationFeature = useIsFeatureInTier(
    'STORE_POLICIES'
  );

  useEffect(() => {
    setIsLoading(true);
    if (!hasTermsNConditionsInformationFeature) return;
    getStorePoliciesAndPrivacyConfigApi()
      .toPromise()
      .then(response => {
        setPoliciesAndPrivacy(response);
      })
      .catch(err => {
        setError(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [hasTermsNConditionsInformationFeature]);

  const savePolicyAndPrivacy = (enabled: boolean, description: string) => {
    setIsLoading(true);
    saveStorePoliciesAndPrivacyConfigApi({
      enabled,
      description,
    })
      .toPromise()
      .then(response => {
        setPoliciesAndPrivacy(response);
        showToast({
          message: 'Políticas y privacidad guardadas',
          title: 'Guardado',
          type: 'success',
        });
      })
      .catch(err => {
        setError(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return {
    error,
    isLoading,
    policiesAndPrivacy,
    savePolicyAndPrivacy,
  };
}

const faqQuestionSelector = (state: RootState) => state.legalConfig.questions;

export function useFaqQuestion() {
  const fetchFaqConfig = useActions(actions.fetchStoreFaqConfig);

  const faqQuestions = useSelector(faqQuestionSelector);

  const hasFaqInformationFeature = useIsFeatureInTier('STORE_POLICIES');

  useEffect(() => {
    if (!hasFaqInformationFeature) return;
    if (Array.isArray(faqQuestions)) return;
    fetchFaqConfig();
  }, [faqQuestions, fetchFaqConfig, hasFaqInformationFeature]);

  return {
    faqQuestions,
  };
}
